import { Step } from "react-joyride";

type OrgStep = Step & { meta?: { action: string } };

export const organisationsGlobalAdminTourSteps: OrgStep[] = [
  {
    target: "#org-profile-tab-button",
    content:
      "Organisation Profile: View and manage your own organisation's information, settings, and billing details.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-0" },
  },
  {
    target: "#users-tab-button",
    content:
      "Users: Manage user accounts, permissions, and access levels across organisations.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-1" },
  },
  {
    target: "#connectors-tab-button",
    content:
      "Connectors: Configure integrations with external platforms like Microsoft 365, Monday.com, Worksorted, and Google Calendar.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-2" },
  },
  {
    target: "#manage-template-tab-button",
    content:
      "Manage Templates: Create and edit document templates using markdown with live preview.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-3" },
  },
  {
    target: "#payments-tab-button",
    content:
      "Payments: View payment methods, invoices, and billing history for organisations.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-4" },
  },
  {
    target: "#org-details-tab-button",
    content:
      "Manage Organisations: View and manage all organisations, their settings, and billing information.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-5" },
  },
  {
    target: "#manage-ontology-tab-button",
    content:
      "Manage Ontology: Configure domain knowledge graphs and semantic relationships.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-6" },
  },
  {
    target: "#feedback-tab-button",
    content:
      "Feedback: Review and respond to user-submitted feedback and support requests.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-7" },
  },
];

export const organisationsOrgAdminTourSteps: OrgStep[] = [
  {
    target: "#org-profile-tab-button",
    content:
      "Organisation Profile: View and manage your organisation's information, settings, and configurations.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-0" },
  },
  {
    target: "#users-tab-button",
    content:
      "Users: Manage user accounts, permissions, and access levels within your organisation.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-1" },
  },
  {
    target: "#connectors-tab-button",
    content:
      "Connectors: Configure integrations with external platforms like Microsoft 365, Monday.com, Worksorted, and Google Calendar.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-2" },
  },
  {
    target: "#manage-template-tab-button",
    content:
      "Manage Templates: Create and edit document templates using markdown with live preview.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-3" },
  },
  {
    target: "#payments-tab-button",
    content:
      "Payments: View payment methods, invoices, and billing history for your organisation.",
    placement: "bottom",
    disableBeacon: true,
    meta: { action: "switch-to-tab-4" },
  },
];
